export { default as Card } from "./component";
